<mat-card class="fuse-card-medium card-product" >
  <div style="flex-grow: 2; padding: 1.2rem;padding-top: 1.7rem; min-height: 4rem;text-align: center; ">
    <img src="assets/MAGOCLOUD-logo.png" style="max-width: 200px" alt="MagoCloud" >
  </div>
  <div class="card-product-coloredArea background-orangeMagoCloud">
    <div style="display:flex; flex-direction: column; justify-content: space-between; height: 100%;">
      <div>
        <h1 style="margin-top: 1.5rem;" class="color-white">MagoCloud</h1>
        <p style="font-size: 1.1rem;" class="color-white">{{this.subTitleContent}}</p>
      </div>
      <div style="width: 100%; text-align: right; margin-top: 2rem;">
        <div (click)="navigate()" style="cursor: pointer" class="circleMediumIcon"><mat-icon>tune</mat-icon></div>
      </div>
    </div>
  </div>
</mat-card>


